package cc.easyandroid.extensions_compose.mvi

import cc.easyandroid.easycompose.mvi.store.Reducer

// 1. 定義 DSL
interface ReducerScope<State> {
    val state: State
}

// 對應的 DSL Builder
fun <State, Message> createReducer(builder: ReducerDsl<State, Message>.() -> Unit): Reducer<State, Message> {
    return ReducerDsl<State, Message>().apply(builder).build()
}

class ReducerDsl<State, Message> {
    val handlers = mutableListOf<Reducer<State, Message>>()

    inline fun <reified T : Message> onMessage(noinline handler: ReducerScope<State>.(message: T) -> State) {
        handlers.add(Reducer { message: Message ->
            if (message is T) {
                object : ReducerScope<State> {
                    override val state: State = this@Reducer
                }.handler(message)
            } else {
                this@Reducer
            }
        })
    }

    fun build(): Reducer<State, Message> = Reducer { message ->
        handlers.fold(this) { currentState, handler ->
            handler.run {
                currentState.reduce(message)
            }
        }
    }

}